import gql from 'graphql-tag';

export const validationFragment = gql`
  fragment validationFragment on ValidationResult {
    success
    errors {
      path
      reason
    }
  }
`;
